export default "__VITE_ASSET__DhQC$XMN__"